import React from 'react';
import Webcam from "react-webcam";
import dice from '../images/dice.jpg';

function UnfairDice() {
    return (
      <div className="App">
        <header className="App-header">
            Unfair Dice Simulator
            <img src={dice} style={{width:'25%', height:'25%'}} alt="dice" />
            6
            <br />
            (reload to play again)

        </header>
        {/* <header className="App-header">
        </header> */}
      </div>
    );
}
  
  export default UnfairDice;
  